import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-listing-item',
  templateUrl: './listing-item.component.html',
  styleUrls: ['./listing-item.component.scss']
})
export class ListingItemComponent implements OnInit {

  @Input()
  source: any = null;

  isLoaded = false;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  goToDetails() {
    if (this.source.id || this.source.objectID) {
      this.router.navigate(['listing/details', this.source.id || this.source.objectID]);
    }
  }

  loadingDone() {
    setTimeout(() => {
      this.isLoaded = true;
    }, 200);
  }

}
